import {
  ContentLayerV2 as ContentLayerComponentV2,
  type WithFocusLockProps,
  withFocusLock,
} from '@volkswagen-onehub/components-core';
import type {
  ContentLayerV2OptionsV2,
  LayerV2,
} from '@volkswagen-onehub/layer-manager';
import * as React from 'react';
import ReactDOM from 'react-dom';

import {LayerContent} from './layer-content';

export interface ContentLayerV2Props {
  readonly layer: LayerV2<unknown, ContentLayerV2OptionsV2>;
  readonly active: boolean;
  scrollElementRef(el: HTMLDivElement): void;
}

const Layer: React.FunctionComponent<ContentLayerV2Props> = (props) => {
  const {layer, active, scrollElementRef, ...ownProps} = props;
  const {withoutHeader} = layer.options;

  if (withoutHeader) {
    return (
      <ContentLayerComponentV2
        {
          ...ownProps /* Used to pass through the animation props */
        }
        active={active}
        scrollElementRef={(el: HTMLDivElement) => {
          scrollElementRef(ReactDOM.findDOMNode(el) as HTMLDivElement);
        }}
        withoutHeader
        aria-labelledby={layer.options['aria-labelledby']}
      >
        <LayerContent layer={layer} />
      </ContentLayerComponentV2>
    );
  }

  return (
    <ContentLayerComponentV2
      {
        ...ownProps /* Used to pass through the animation props */
      }
      active={active}
      aria-labelledby={layer.options['aria-labelledby']}
      scrollElementRef={(el: HTMLDivElement) => {
        scrollElementRef(ReactDOM.findDOMNode(el) as HTMLDivElement);
      }}
      closeButtonLabel={layer.options.closeButtonLabel}
      contentHeadline={layer.options.contentHeadline}
      disableDefaultPadding={layer.options.disableDefaultPadding}
      onClose={layer.close}
    >
      <LayerContent layer={layer} />
    </ContentLayerComponentV2>
  );
};

const ContentLayerV2WithLock = withFocusLock<ContentLayerV2Props>(Layer);
ContentLayerV2WithLock.displayName = 'ContentLayerV2WithLock';

export const ContentLayerV2: React.ElementType = (
  props: ContentLayerV2Props & WithFocusLockProps,
) => {
  return <ContentLayerV2WithLock {...props} disabled={props.layer.isClosed} />;
};
